import React from 'react'
import { Helmet } from 'react-helmet'
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader'
import NOC1 from '../../../Componet/NOC/NOC1He'
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm'

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer'

function NOCHePage() {
    return (
        <div className="noc-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - מרכז בקרה ורשת (NOC)</title>
                <meta
                    name="description"
                    content="שירותי NOC וניטור לעסקים שצריכים נראות בזמן אמת, תגובה מהירה יותר, רציפות שירות ושכבת בקרה מקצועית על תשתיות ורשתות."
                />
                <meta
                    name="keywords"
                    content="NOC, מרכז בקרה, ניטור תשתיות, ניטור רשת, 24/7 monitoring, incident response, uptime, network operations"
                />
                <meta property="og:title" content="EpicFinal - מרכז בקרה ורשת (NOC)" />
                <meta
                    property="og:description"
                    content="ניטור רציף, זיהוי תקלות בזמן אמת, תגובה תפעולית ושכבת בקרה מקצועית לשמירה על יציבות ורציפות שירות."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/noc" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - מרכז בקרה ורשת (NOC)" />
                <meta
                    name="twitter:description"
                    content="NOC לעסקים שצריכים שליטה, זמינות ותגובה מהירה יותר."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"מרכז בקרה ורשת (NOC)"} />
            <div className="page-content">
                <NOC1 />
                <ConsultingForm
                    language="he"
                    formId="epic-noc-form"
                    conversionSendTo="AW-11461100984/3ccMCLH7tJgcELiLitkq"
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="ספרו לנו מה קורה בתשתית או ברשת שלכם"
                    subtitle="השאירו פרטים קצרים ונחזור אליכם עם מענה מקצועי והכוונה ראשונית לניטור ול-NOC שלכם."
                />
                <NewsletterL1 />
            </div>
        </div>
    )
}

export default NOCHePage

